import { CertificateIssuanceFormData } from "../data/CertificateIssuanceForm.data";


export const setAllDropDownField = (apiResponse) => {
    const filterDropDownList = (dropdownName) => {
        return apiResponse.reduce((acc, item) => {
            if (item.dropdownName === dropdownName) {
                acc.push({
                    value: item.id,
                    label: item.name,
                });
            }
            return acc;
        }, [{value: 0,label: "All",}]);
    }

    const dropdownLists = {
        "statusId": filterDropDownList("Certificate Issuance"),
    };

    const formFields = [...CertificateIssuanceFormData.formFields,];

    formFields.forEach(field => {
        const dropdownList = dropdownLists[field?.id];
        if (dropdownList) {
            field.fieldSetting.options = dropdownList;
        }
    });
};